import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IInstitutionPlan } from '../interfaces/institution.interface';

/**
 * Institution plan tier + seat usage. Readable by any institution member (tenancy-guarded
 * server-side). `employeeCap`/`allowedModules` come back populated for PAID institutions too —
 * callers must branch on `planTier`, never on cap presence.
 */
export const PlanService = {
    getPlan: async (institutionId: string): Promise<IInstitutionPlan> => {
        const response = await axios.get(
            ENDPOINTS.INSTITUTION.PLAN(institutionId),
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },
};
